import { useEffect, useState } from 'react';

import { usePathname, useRouter } from 'expo-router';

import { routes } from 'navigation/routing';
import { useOrderContext } from 'state/order';
import { useServiceModeContext } from 'state/service-mode';
import { shouldRedirectToMenu } from 'utils/cart-utils';

import { cartHasQualifyingRedirectContent } from '../utils';

import { useCartContext } from './use-cart-context';

export const useCartRedirectToMenu = () => {
  const { cartEntries } = useCartContext();
  const pathname = usePathname();
  const router = useRouter();
  const { serviceMode } = useServiceModeContext();
  const { serverOrder } = useOrderContext();

  const orderServiceMode = serverOrder?.cart?.serviceMode;
  const orderStatus = serverOrder?.status ?? null;

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const isCartRoute = pathname === routes.cart;
    setIsMounted(isCartRoute);
  }, [pathname]);

  const hasQualifyingContent = cartHasQualifyingRedirectContent(cartEntries);

  useEffect(() => {
    if (
      shouldRedirectToMenu({
        isMounted,
        cartEntries,
        orderStatus,
        serviceMode,
        orderServiceMode,
        hasItemsOrCombos: hasQualifyingContent,
      })
    ) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          router.replace(routes.menu);
        });
      });
    }
  }, [
    cartEntries,
    hasQualifyingContent,
    isMounted,
    orderServiceMode,
    orderStatus,
    router,
    serviceMode,
  ]);
};
